import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useEffect } from "react";
import axios from "axios";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDEER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MESUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firebaseAuth = getAuth();

function useHandleLogin() {
  useEffect(() => {
    const auth = getAuth();
    let refreshTokenInterval;

    const refreshToken = async (force = false) => {
      const currentUser = auth.currentUser;
      if (currentUser) {
        try {
          const idToken = await currentUser.getIdToken(force); // force refresh if needed
          // alert("tokennnnss", idToken);
          // console.log("idToken", idToken);
          window.localStorage.setItem("accessToken", idToken);
          // Update axios headers
          axios.defaults.headers.common.Authorization = idToken;
          console.log(
            force
              ? "🔁 Token force-refreshed on focus"
              : "✅ Token refreshed silently"
          );
        } catch (error) {
          console.error("❌ Error refreshing token:", error);
          // If refresh fails, redirect to login
          window.localStorage.removeItem("accessToken");
          window.location.href = "/secure/login?reason=session_expired";
        }
      }
    };

    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        await refreshToken(); // Get initial token

        refreshTokenInterval = setInterval(() => {
          refreshToken();
        }, 10 * 60 * 1000);
      } else {
        if (refreshTokenInterval) clearInterval(refreshTokenInterval);
        window.localStorage.removeItem("accessToken");
        delete axios.defaults.headers.common.Authorization;
        console.log("👤 User logged out, token cleared");
      }
    });

    // 👇 Detect when user returns to tab and refresh token
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && auth.currentUser) {
        const publicRoutes = ["/", "/features", "/how-it-works", "/blog"];
        const currentPath = window.location.pathname;
        const isPublicRoute = publicRoutes.some((route) =>
          currentPath.startsWith(route)
        );

        if (!isPublicRoute && currentPath !== "/secure/login") {
          refreshToken(true); // force refresh on tab return
        }
      }
    };

    // Detect user activity and refresh if needed
    let activityTimeout;
    const handleActivity = () => {
      clearTimeout(activityTimeout);
      activityTimeout = setTimeout(() => {
        if (auth.currentUser) {
          const token = window.localStorage.getItem("accessToken");
          if (token) {
            try {
              const { exp } = JSON.parse(atob(token.split(".")[1]));
              const now = Date.now() / 1000;
              // Refresh if token expires in less than 5 minutes
              if (exp - now < 300) {
                refreshToken(true);
              }
            } catch (err) {
              console.error("Error parsing token:", err);
              refreshToken(true);
            }
          }
        }
      }, 1000);
    };

    const activityEvents = ["mousedown", "keydown", "scroll", "touchstart"];
    activityEvents.forEach((event) => {
      document.addEventListener(event, handleActivity, { passive: true });
    });

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      unsubscribe();
      if (refreshTokenInterval) clearInterval(refreshTokenInterval);
      clearTimeout(activityTimeout);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      activityEvents.forEach((event) => {
        document.removeEventListener(event, handleActivity);
      });
    };
  }, []);
}

// const signOut = async () => {
//   try {
//     alert("222222")
//     const savedTheme = localStorage.getItem("theme");
//     await firebaseAuth.signOut();
//     localStorage.clear();
//     sessionStorage.clear();
//     // ✅ Restore theme
//     if (savedTheme) {
//       localStorage.setItem("theme", savedTheme);
//     }
//      alert("333333")
//     delete axios.defaults.headers.common.Authorization;
//     console.log("✅ User logged out successfully");
//   } catch (error) {
//     console.error("❌ Error logging out:", error);
//     throw error;
//   }
// };
export { app, firebaseAuth, useHandleLogin };
